import {Controller} from '@stubhub/react-store-provider';

const NAMESPACE = 'viewport';

const controller = new Controller({
  namespace: NAMESPACE,
  actionCreators: {
    updateScreenSize,
  },
  reducers: ['UPDATE_SCREEN_SIZE'],
});

function updateScreenSize(size) {
  return (dispatch) => {
    dispatch({type: 'UPDATE_SCREEN_SIZE', screenSize: size});
  };
}

export default controller;
